module.exports = __webpack_public_path__ + "static/media/speile.0a36f737.m4a";